import { Level } from 'angular2-logger/core';

export const environment = {
  production: true,
  HTTP_BASE_URL : 'https://www.extrus.net:19443/exafe_admin',
  logger : {
    level : Level.OFF
  },
  kyungnamIsTrue : false,
  nambuIsTrue : false,
  dtaqIsTrue : false         //국방기술품질원    // 긴급해제 정책 로그 히든처리 true-사용 false- 미사용
};



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/environments/environment.ts